import React from 'react'
import section_image_incuspaze from "../../../../assets/case-section-4.png"
import section_image_phenom from '../../../../assets/Phenom_hirestar.png'
import section_image_goken from '../../../../assets/goken_hirestar.png'
import section_image_ikf from '../../../../assets/ikf_hirestar.png'
import section_image_monitra from '../../../../assets/monitra_hirestar.png'

import { useParams } from 'react-router-dom';
const CaseStudySection4 = {
  phenom: {
    background_image: section_image_phenom,
  },
  goken:{
    background_image: section_image_goken,
  },
  ikf:{
    background_image: section_image_ikf,
  },
  monitra:{
    background_image: section_image_monitra,
  },
  incuspaze: {
    background_image: section_image_incuspaze
  }
}
export default function PhenomCaseSection4() {
     const { companyName } = useParams(); // For Getting the Route Name
        const { background_image } = CaseStudySection4[companyName]; // Render the content accourding to the param or company name
  return (
       <section className="mx-4   flex items-center justify-center">
            <div className="text-center p-6">
                
                <div>
                    <img src={background_image} alt="" srcset="" />
                </div>
            </div>
        </section>
  )
}
